var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17"}},[_c('path',{attrs:{"d":"M15 6.768c1.333.77 1.333 2.694 0 3.464L3.75 16.727c-1.333.77-3-.192-3-1.732V2.005c0-1.54 1.667-2.502 3-1.732L15 6.768z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }